export default [
  {
    path: "/plan-shopping-layout",
    component: () => import("@/layouts/plan-shopping-layout/PlanShoppingLayout.vue"),
    children: [
      {
        path: "/plans",
        name: "plan-shopping",
        component: () => import("@/modules/plan-shopping/pages/plan-shopping-flow/PlanShoppingFlow.vue")
      }
    ]
  }
]
